import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'isContainedInControlValuePipe'
})
export class IsContainedInControlValuePipe implements PipeTransform {

  transform(value: any, cFormControlValue: any): boolean {
    return Array.isArray(cFormControlValue) && cFormControlValue.includes(value) || cFormControlValue === value;
  }

}
